import React, { memo } from "react"
import { ForecastNode as ForecastNodeType } from "@features/builder/graph/types"
import NodeContainer from "./NodeContainer"

export const ForecastNode = memo((node: ForecastNodeType) => {
  return (
    <NodeContainer node={node}>
      <div className="graph-node-container">
        <div className="graph-node-type graph-node-forecast">{node.type}</div>
        <div className="graph-node-label">{node.data.label}</div>
      </div>
    </NodeContainer>
  )
})

ForecastNode.displayName = "ForecastNode"
